/* eslint-disable array-callback-return */
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import * as yup from 'yup';
import { useCookiesLogin } from '../../config/cookies';

import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { greenColor } from '../../config/colors';
import { HOST_API } from '../../config/hosts';

import { Backdrop, Button, CircularProgress, Typography } from '@mui/material';
import { useLocation, useSearchParams } from 'react-router-dom';
import Header from '../../components/Header';
import PaymentModal from '../../components/PaymentModal';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from '../../hooks/useTranslation';
import PaymentMethodSelector from '../../components/PaymentMethodSelector';
import { Add, Remove } from '@mui/icons-material';
import PaymentCreditCardModal from '../../components/PaymentCreaditCardModal';
import { usePayment } from '../../context/PaymentContext';
import { usePaymentMonitor } from '../../hooks/usePaymentMonitor';
import { formatMoney } from '../../utils';
import api from '../../services/api';
import ModalAddress from './ModalAddress';
import ModalAfterConsult from '../../components/ModalAfterConsult';

const RedCoins = () => {
  const { cookies } = useCookiesLogin();
  const [isLoading, setIsLoading] = useState(false);
  const { id, last_company: bussines_id, name, email } = cookies.AUTH_TOKEN;
  const [totalPrice, setTotalPrice] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [resume, setResume] = useState(false);
  const [resumePayment, setResumePayment] = useState(false);
  const [paymentResumeId, setPaymentResumeId] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [plans, setPlans] = useState([]);
  const [paymentModal, setPaymentModal] = useState(null);
  const [paymentData, setPaymentData] = useState(null);
  const [showCreditCard, setShowCreditCard] = useState(false);
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const { t } = useTranslation();
  const [customizedQuantity, setCustomizedQuantity] = useState(0);
  const [consultations, setConsultations] = useState();
  const [avulsoPrice, setAvulsoPrice] = useState(65);

  const [openAddressModal, setOpenAddressModal] = useState(false);

  const location = useLocation();
  const [showAfterConsult, setShowAfterConsult] = useState(false);

  useEffect(() => {
    if (location?.state?.showAfterConsult) {
      setShowAfterConsult(true);
      window.history.replaceState({}, '');
    }
  }, [location.state]);

  const getValuePerConsultation = (quantity) => {
    if (!plans || plans.length === 0) return avulsoPrice;
    const sorted = [...plans].sort((a, b) => a.amount - b.amount);
    let unitPrice = avulsoPrice;
    for (const plan of sorted) {
      if (quantity >= plan.amount) unitPrice = plan.unit_price;
    }
    return unitPrice;
  };

  const valuePerConsultation = getValuePerConsultation(customizedQuantity);
  const customizedTotal = Math.round(customizedQuantity * valuePerConsultation * 100) / 100;
  const { setSubscriptionId } = usePayment();
  usePaymentMonitor();

  const incrementValue = () => {
    setCustomizedQuantity((prev) => prev + 1);
  };

  const decreaseValue = () => {
    if (customizedQuantity > 0) {
      setCustomizedQuantity((prev) => prev - 1);
    }
  };

  useEffect(() => {
    fetchPlans();
    fetchConsultations();
    fetchAvulsoPrice();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!resume && customizedQuantity > 0) {
      setCustomizedQuantity(0);
    }
  }, [resume]);

  const fetchPlans = async () => {
    try {
      const { token } = cookies.AUTH_TOKEN;
      const response = await fetch(`${HOST_API}/v1/plan`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        setPlans(data.data || []);
      }
    } catch (error) {
      console.error(t('messages.errorFetchingPlans'), error);
    }
  };

  const fetchAvulsoPrice = async () => {
    try {
      const { token } = cookies.AUTH_TOKEN;
      const response = await fetch(`${HOST_API}/v1/plan/consultation-price`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (response.ok) setAvulsoPrice(data.price);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchConsultations = async () => {
    try {
      const { token } = cookies.AUTH_TOKEN;
      const response = await fetch(`${HOST_API}/v1/dashboard/balance?ordersQuantity=true`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        setConsultations(
          {
            balance: data?.balance,
            ordersCount: data?.orders_count,
          } || []
        );
      }
    } catch (error) {
      console.error(t('messages.errorFetchingPlans'), error);
    }
  };

  const initialValues = {
    quantity: '',
  };

  const handleCardClick = (plan) => {
    setTotalPrice(plan.price);
    setQuantity(plan.amount);
    setResume(true);
  };

  const handleCustomizeQuantity = () => {
    setTotalPrice(customizedTotal);
    setQuantity(customizedQuantity);
    setResume(true);
  };

  const valuesSchema = yup.object().shape({
    quantity: yup
      .number()
      .min(10, t('messages.minQuantity'))
      .required(t('messages.quantityRequired')),
  });

  async function sendResume() {
    setIsLoading(true);
    setSubmitting(true);

    if (quantity <= 0) {
      toast.info(t('messages.quantityCannotBeZero'), {
        theme: 'dark',
      });
      setIsLoading(false);
      return;
    }

    const requestBody = {
      client_id: id,
      business: bussines_id,
      status_payment: 'PAYMENT',
      quantity: quantity,
      total_value: totalPrice,
    };

    try {
      const response = await fetch('https://back.redutocapital.com.br/reduto/request/coins', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok) {
        setResumePayment(true);
        setPaymentResumeId(data.resume_id);
        toast.success(t('messages.tokensRequestedSuccess'), {
          theme: 'dark',
        });
      } else {
        toast.error(t('messages.errorRequestingTokens'), {
          theme: 'dark',
        });
      }
    } catch (error) {
      toast.error(t('messages.networkErrorTokens'), {
        theme: 'dark',
      });
    } finally {
      setIsLoading(false);
      setSubmitting(false);
    }
  }

  const createSubscription = async (type, cardHash = null) => {
    try {
      const { token } = cookies.AUTH_TOKEN;

      const { data: currentUser } = await api.get(`${HOST_API}/v1/currentUser`);

      if (!currentUser.company?.address || !currentUser.company?.taxvar) {
        setOpenAddressModal(true);
        return;
      }

      const body = {
        type: type,
        total: totalPrice,
        amount: quantity,
      };

      if (cardHash) {
        body.cardHash = cardHash;
      }

      const response = await fetch(`${HOST_API}/v1/subscription/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();

      if (response.ok) {
        setPaymentData(data);
        setSubscriptionId(data.id);
        setPaymentModal(type);
      } else {
        toast.error(t('messages.errorCreatingSubscription'));
      }
    } catch (error) {
      toast.error(t('messages.networkError'));
    }
  };

  const onSubmit = async ({ errors, payment_method }) => {
    if (errors && errors.length > 0) {
      toast.error(t('messages.verifyRegisteredData'));
      return;
    }

    if (payment_method?.encrypted) {
      await createSubscription('credit_card', payment_method.encrypted);
      setShowCreditCard(false);
    }
  };

  return (
    <>
      <ModalAfterConsult open={showAfterConsult} onClose={() => setShowAfterConsult(false)} />
      <Box padding={3}>
        <Box>
          <ToastContainer />

          {resume === false ? (
            <>
              <Header title={t('titles.requestConsultation')} />
              <Box
                sx={{
                  maxWidth: 900,
                  display: 'flex',
                  gap: '8px',
                  marginBottom: '20px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    backgroundColor: '#ffffff',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                    paddingX: '16px',
                    paddingY: '32px',
                    borderRadius: '8px',
                    width: '270px',
                  }}
                >
                  <Typography
                    sx={{
                      color: '#0E1025',
                      fontSize: {
                        xs: '16px',
                        md: '18px',
                      },
                    }}
                  >
                    {t('payment.consultationsAvailable')}
                  </Typography>
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        color: '#2C2C2C',
                        fontSize: {
                          xs: '16px',
                          md: '18px',
                        },
                        fontWeight: '700px',
                      }}
                    >
                      {consultations?.balance}
                    </Typography>
                    <Typography
                      sx={{
                        color: '#737373',
                        fontSize: '12px',
                      }}
                    >
                      ({t('payment.quantity')})
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    backgroundColor: '#ffffff',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                    paddingX: '16px',
                    paddingY: '32px',
                    borderRadius: '8px',
                    width: '270px',
                  }}
                >
                  <Typography
                    sx={{
                      color: '#0E1025',
                      fontSize: {
                        xs: '16px',
                        md: '18px',
                      },
                    }}
                  >
                    {t('payment.consultationsAlreadyUsed')}
                  </Typography>
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        color: '#2C2C2C',
                        fontSize: {
                          xs: '16px',
                          md: '18px',
                        },
                        fontWeight: '700px',
                      }}
                    >
                      {consultations?.ordersCount}
                    </Typography>
                    <Typography
                      sx={{
                        color: '#737373',
                        fontSize: '12px',
                      }}
                    >
                      ({t('payment.quantity')})
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Typography
                sx={{
                  fontSize: '20px',
                  color: 'rgb(115, 115, 115, 0.7)',
                  marginBottom: '20px',
                }}
              >
                {t('payment.selectQuantity')}
              </Typography>
              <Box sx={{ maxWidth: 650, marginBottom: '20px' }}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" sx={{ mb: 2, color: '#1D2530', fontSize: '18px' }}>
                    {t('payment.consultation')} ({t('payment.quantity')})
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, maxWidth: '600px' }}>
                    <Button
                      onClick={decreaseValue}
                      sx={{
                        paddingY: '16px',
                        paddingX: '12px',
                        border: '1px solid #E4EBF1',
                        bgcolor: 'white',
                        '&:hover': { bgcolor: '#f0f0f0' },
                      }}
                    >
                      <Remove />
                    </Button>

                    <Box
                      sx={{
                        flex: 1,
                        background: '#E5FFD499',
                        border: '2px solid #83D84D',
                        borderRadius: 2,
                        py: '12px',
                        textAlign: 'center',
                      }}
                    >
                      <Typography variant="h3" sx={{ color: '#1D2530' }}>
                        {customizedQuantity}
                      </Typography>
                    </Box>

                    <Button
                      onClick={incrementValue}
                      sx={{
                        paddingY: '16px',
                        paddingX: '12px',
                        border: '1px solid #E4EBF1',
                        bgcolor: 'white',
                        '&:hover': { bgcolor: '#f0f0f0' },
                      }}
                    >
                      <Add />
                    </Button>
                  </Box>
                </Box>

                {customizedQuantity > 0 && (
                  <Box
                    sx={{
                      backgroundColor: '#ffffff',
                      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                      display: 'flex',
                      padding: '16px',
                      borderRadius: '8px',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      gap: 2,
                      maxWidth: '600px',
                    }}
                  >
                    <Typography variant="h3" sx={{ fontWeight: 600, color: '#737373' }}>
                      {t('payment.value')} (R$): {formatMoney(customizedTotal)}
                    </Typography>

                    <Button
                      onClick={handleCustomizeQuantity}
                      variant="contained"
                      size="large"
                      sx={{
                        bgcolor: '#83D84D',
                        '&:hover': { bgcolor: '#57a05a' },
                        fontWeight: 'bold',
                        px: 4,
                        py: 1.5,
                        color: '#2C2C2C',
                      }}
                    >
                      {t('buttons.request')}
                    </Button>
                  </Box>
                )}
              </Box>
              <Formik initialValues={initialValues} validationSchema={valuesSchema}>
                {({
                  values,
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                }) => {
                  const totalPrice = values.price || 0;

                  return (
                    <form onSubmit={handleSubmit}>
                      <Box
                        display="grid"
                        columnGap="40px"
                        rowGap="30px"
                        gridTemplateColumns={{
                          xs: '1fr',
                          sm: '1fr 1fr',
                        }}
                        sx={{ maxWidth: 900 }}
                      >
                        {plans.map((plan) => (
                          <Box
                            key={plan.id}
                            sx={{
                              padding: '20px',
                              backgroundColor: '#ffffff',
                              borderRadius: '8px',
                              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                              transition: 'transform 0.3s ease-in-out',
                              '&:hover': {
                                transform: 'scale(1.05)',
                              },
                            }}
                          >
                            <Typography
                              variant="h5"
                              gutterBottom
                              sx={{
                                fontSize: 24,
                                color: 'rgb(115, 115, 115, 0.7)',
                              }}
                            >
                              {plan.name}
                            </Typography>
                            <Typography
                              variant="body1"
                              gutterBottom
                              sx={{
                                fontSize: 24,
                                color: '#2C2C2C',
                              }}
                            >
                              {Number(plan.price).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </Typography>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => handleCardClick(plan)}
                              sx={{
                                mt: 2,
                                backgroundColor: '#83D84D',
                                '&:hover': {
                                  backgroundColor: '#6bb03a',
                                },
                                fontWeight: 'bold',
                                color: '#2C2C2C',
                              }}
                            >
                              {t('buttons.request')}
                            </Button>
                          </Box>
                        ))}
                      </Box>
                    </form>
                  );
                }}
              </Formik>
            </>
          ) : (
            <PaymentMethodSelector
              t={t}
              quantity={quantity}
              totalPrice={totalPrice}
              name={name}
              email={email}
              paymentResumeId={paymentResumeId}
              resume={resume}
              setResume={setResume}
              resumePayment={resumePayment}
              setResumePayment={setResumePayment}
              setShowCreditCard={setShowCreditCard}
              createSubscription={createSubscription}
              showCreditCard={showCreditCard}
              onBack={() => {
                setResume(false);
                setResumePayment(false);
              }}
              onSubmit={onSubmit}
            />
          )}

          <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
            <CircularProgress color="inherit" sx={{ color: greenColor }} />
          </Backdrop>

          {paymentModal && (
            <PaymentModal
              type={paymentModal}
              data={paymentData}
              onClose={() => {
                setPaymentModal(null);
                setPaymentData(null);
              }}
            />
          )}

          {showCreditCard && (
            <PaymentCreditCardModal onClose={() => setShowCreditCard(false)} onSubmit={onSubmit} />
          )}

          <ModalAddress open={openAddressModal} onClose={() => setOpenAddressModal(false)} />
        </Box>
      </Box>
    </>
  );
};

export default RedCoins;
